export default {
  title: 'Account settings',
  changeAvatar: 'Change avatar',
  information: 'Information',
};
